import VendorAPIManager from '../repository/vendor';
import { useQlubRouter } from './router';
import { onPushEvent } from '../lib/gtm';
import { getDiningSession, getSession } from '../service/session/dsi';

export const profileEventsCenter = () => {
    const { url, source } = useQlubRouter();
    // we are accessing this function in the auth context so we can not get the data from vendor context
    const vendor = VendorAPIManager.getInstance().getVendorCache(url);

    const dsi = getDiningSession(url)?.id;
    const sessionID = getSession();

    const universalParams = {
        party_id: sessionID,
        country_code: url.cc,
        restaurant_name: url.slug,
        pg_name: vendor?.availablePGs,
        diningSessionId: dsi,
    };

    const userProfile = {
        tapOnLoginEvent: () => {
            onPushEvent('tap_on_login', {
                ...universalParams,
                source,
            });
        },
        isUserProfileEnabledEvent: (isAuthorizedUser: boolean) => {
            onPushEvent('user_profile_enabled', {
                ...universalParams,
                user_logged_in: isAuthorizedUser,
            });
        },
        attemptToLoginEvent: (method: string) => {
            onPushEvent('attempt_to_login', {
                ...universalParams,
                source,
                login_method: method,
            });
        },
        submitOTPEvent: () => {
            onPushEvent('submit_otp', {
                ...universalParams,
                source,
            });
        },
        resendOPTEvent: () => {
            onPushEvent('resend_otp', {
                ...universalParams,
                source,
            });
        },
        successfulLoginEvent: (method: string, isNewUSer?: boolean) => {
            onPushEvent('successful_login', {
                ...universalParams,
                source,
                login_method: method,
                is_first_login: isNewUSer || false,
            });
        },
        tapOnProfileEvent: () => {
            onPushEvent('tap_on_profile_button', {
                ...universalParams,
                source,
            });
        },
    };

    return {
        userProfile,
    };
};
